import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Alert, Spinner, useAsync } from '@wix/cli-ui-kit';
import { useBackendAsAServiceClient } from '@wix/backend-as-a-service-client';
import { useProjectModel } from '../../model.js';

const ENV_NAME = 'prod';

export const EnvSet: FC<{ variable: { key: string; value: string } }> = ({
  variable,
}) => {
  const { model } = useProjectModel();
  const backendAsAServiceClient = useBackendAsAServiceClient();

  const { status } = useAsync(async () => {
    await backendAsAServiceClient.upsertAppEnvironment(
      model.config.appId,
      ENV_NAME,
      {
        [variable.key]: variable.value,
      }
    );
  }, []);

  return match(status, {
    Loading: () => <Spinner text="Setting environment variable..." />,
    Success: () => (
      <Alert type="success">"{variable.key}" was successfully set</Alert>
    ),
    Error: () => null,
    NotRequested: () => null,
  });
};
